<template>

    <div>

        <div class="container">
            <div class="product">
                <div class="main">
                    <div class="row">
                        <div class="col-lg-6">
                            <div v-if="images.length > 1">
                                <vueper-slides
                                    ref="mainProductSlider"
                                    class="no-shadow"
                                    :fixedHeight="getFixedHeight"
                                    :autoplay="false"
                                    :dragging-distance="200"
                                    @slide="$refs.thumbsProductSlider.goToSlide($event.currentSlide.index, { emit:false })"
                                >
                                    <vueper-slide
                                        v-for="(image, i) in images"
                                        :key="i"
                                        :image="image.url"
                                    />
                                </vueper-slides>

                                <vueper-slides
                                    ref="thumbsProductSlider"
                                    :autoplay="false"
                                    class="no-shadow"
                                    fixedHeight="75px"
                                    :visible-slides="images.length"
                                    :arrows="false"
                                    :duration="5000"
                                    :dragging-distance="200"
                                    :gap="2"
                                    @slide="$refs.mainProductSlider.goToSlide($event.currentSlide.index, { emit:false })"
                                >
                                    <vueper-slide
                                        class="mt-2"
                                        v-for="(image, i) in images"
                                        :key="i"
                                        :image="image.url"
                                        style="cursor:pointer;"
                                        @click.native="$refs.thumbsProductSlider.goToSlide(i)"
                                    />
                                </vueper-slides>
                            </div>
                            <div v-else-if="images.length === 1">
                                <img
                                    :src="images[0].url"
                                    :alt="images[0].name"
                                />
                            </div>
                            <div v-else>
                                <img
                                    :src="require('../../../../sass/sustainableclothing/img/no-product-image.jpg').default"
                                    :alt="product.data.name"
                                />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h1 class="product_title">{{ product.data.name }}</h1>

                            <p
                                class="price"
                                v-if="isAuthenticated && product.data.min_price !== product.data.price"
                            >

                                {{ product.data.min_price | toCurrency }}
                                –
                                {{ product.data.price | toCurrency }}
                            </p>

                            <p v-html="product.data.description"></p>

                            <add-to-cart
                                :product="product.data"
                                :stock-data="stockData"
                                @variant-selected="variantSelected"
                                @option-selected="optionSelected"
                                @ShowRestock="showRestock"
                            ></add-to-cart>

                            <table class="table table-striped table-hover mt-5">
                                <tbody>
                                    <tr>
                                        <td v-html="lang('products.show.brand') + ':'"></td>
                                        <td>
                                            <inertia-link
                                                :href="route('brands.item', {slug:product.data.brand.slug})"
                                            >{{ product.data.brand.name }}</inertia-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td v-html="lang('products.show.modelcode') + ':'"></td>
                                        <td>{{ product.data.code }}</td>
                                    </tr>
                                    <tr v-if="sku !== null">
                                        <td v-html="lang(eanSkuLangKey) + ':'"></td>
                                        <td>{{ sku }}</td>
                                    </tr>
                                    <tr v-if="product.data.categories.length">
                                        <td v-html="lang('products.show.categories') + ':'"></td>
                                        <td>
                                            <inertia-link
                                                v-for="(category, key) in product.data.categories"
                                                :key="'category-' + category.slug + '-' + key"
                                                :href="route('categories.item', {slug:category.slug})"
                                            >
                                                <span v-if="key !== 0">,</span>
                                                {{ category.name }}
                                            </inertia-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!--            <div class="information mt-5">
                    <div class="row">
                        <div class="col-6">
                            <h2>Product omschrijving</h2>
                            <p v-html="product.data.description"></p>
                        </div>
                        <div class="col-6">
                            <h2>Extra informatie</h2>

                            <table class="table table-hover">
                                <tbody>
                                    <tr
                                        v-for="option in product.data.options"
                                    >
                                        <th>
                                            {{ option.name }}
                                        </th>
                                        <td>
                                            <p>{{ product.data.option_values
                                                .filter(ov => ov.option_uuid === option.uuid)
                                                .map(value => value.name)
                                                .join(', ')
                                                }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>-->
            </div>
        </div>

        <div class="related">
            <div class="container">
                <h3>{{ lang('products.show.related') }}</h3>
                <div class="row productscontainer relatedproducts">
                    <div
                        v-if="related.data.length === 0"
                        class="col-12"
                    >
                        <p>{{ lang('products.show.no-related') }}</p>
                    </div>
                    <div
                        v-for="product in related.data"
                        class="mb-5 col-6 col-md-4 col-lg-2"
                    >
                        <overview-item
                            :product="product"
                        ></overview-item>
                    </div>
                </div>
            </div>
        </div>

        <restock
            v-if="isAuthenticated"
            ref="restockModal"
        ></restock>
    </div>

</template>

<script>

import axios from 'axios';
import Layout from "../../../Shared/Layout";
import AddToCart from "../../../components/Products/AddToCart";
import Restock from "../../../components/Products/Restock";
import { VueperSlides, VueperSlide } from '../../../Libraries/vueperslides/vueperslides.common';
import OverviewItem from '../../../components/Products/OverviewItem';

export default {

    components: {
        AddToCart,
        Restock,
        VueperSlides,
        VueperSlide,
        OverviewItem,
    },

    computed: {
        eanSkuLangKey() {
            return this.product.data.brand.slug === 'stanleystella' ?
                'products.show.sku' :
                'products.show.ean';
        },

        getFixedHeight() {
            let width = window.innerWidth;

            if (width > 1410) {
                return '675px';
            } else if (width >= 992) {
                return '562px';
            } else if (width >= 768) {
                return '800px';
            } else if (width >= 576) {
                return '637px';
            }
            return '550px';
        },

        images() {
            let main = [];

            if (this.product.data.mainimage) {
                main.push(this.product.data.mainimage);
            }

            if (this.selectedVariant === null) {
                return main;
            }

            let color_option = this.selectedVariant.options.filter(option => option.parent === 'colors');

            if (color_option.length !== 1) {
                return main;
            }

            let color_code = color_option[0].code;

            if (!this.product.data.variant_images[color_code] || this.product.data.variant_images[color_code].length === 0) {
                return main;
            }

            return this.product.data.variant_images[color_code].slice(0, 16);
        },

        isAuthenticated() {
            return !!this.$page.props.auth.email;
        },

        sku() {
            if (this.selectedVariant === null) {
                return null;
            }

            return this.selectedVariant.code;
        },
    },

    data() {
        return {
            selectedVariant:null,
            stockData:{},
        }
    },

    layout:Layout,

    metaInfo() {
        return {
            title:this.product.data.name,
            meta: [
                { name: 'description', content: this.product.data.name }
            ],
        }
    },

    methods: {
        getStockData() {
            if (!this.isAuthenticated) {
                return;
            }

            axios.get(this.route('api.v1.stock.show', this.product.data.code))
                .then(resp => this.stockData = resp.data.data);
        },

        findVariantBasedOnColorCode(code) {
            let variant = this.product.data.variants.filter(variant => {
                return variant.options.filter(option => {
                    return option.code === code;
                }).length > 0;
            });

            if (variant.length === 0) {
                return null;
            }

            return variant[0];
        },

        optionSelected(option) {
            let variant = this.findVariantBasedOnColorCode(option.code);

            if (variant) {
                this.selectedVariant = variant;
            }
        },

        showRestock(sku) {
            this.$refs.restockModal.showRestock(sku);
        },

        variantSelected(variant) {
            this.selectedVariant = variant;
            this.$GA4.dispatch('select_item');

            if (this.images.length > 1) {
                setTimeout(() => {
                    this.$refs.mainProductSlider.goToSlide(0);
                }, 50);
            }
        },
    },

    mounted() {
        this.$GA4.dispatch('view_item');
        this.getStockData();
    },

    name:'OpenProductsShow',

    props: {
        product: {
            required:true,
        },
        related: {
            required:true,
        },
    },

}

</script>
